import React from 'react';
import styles from '../static/styles/PremiumUpgrade.module.css';
import { useNavigate } from 'react-router-dom';
import ArrowLeft from '../static/img/backArrow.png'
import { useEffect } from 'react';
import { trackPremiumTrialStart, trackPremiumUpgradePageView } from '../utils/analytics';

const PremiumUpgrade = () => {
    const navigate = useNavigate();

    useEffect (() => {
        document.title = "GO PREMIUM | JAZZ ESL"
        trackPremiumUpgradePageView();
    }, [])

    const perks = [
        {
            icon: '🚀',
            title: '1.2× POINTS BOOST',
            desc: 'Earn 20% more credits on every task, game & tournament',
            tag: '+20%'
        },
        {
            icon: '🥇',
            title: 'FREE TOURNAMENTS',
            desc: 'Zero entry fees — compete unlimited every week',
            tag: 'FREE'
        },
        {
            icon: '🎁',
            title: 'EXCLUSIVE GIFT SHOP',
            desc: 'PS5, gaming mice, headsets & keyboards unlocked',
            tag: 'VIP'
        },
        {
            icon: '👑',
            title: 'GOLD VIP STATUS',
            desc: 'Gold badge · Priority queue · Dedicated support',
            tag: '★'
        }
    ];

    const onPremiumLpRedirect = () => {
        const baseUrl = process.env.REACT_APP_PREMIUM_JAZZCASH_LP_URL;

        if (!baseUrl) {
            console.error("redirect url is not defined");
            return;
        }

        const url = new URL(baseUrl);
        url.searchParams.set("ref", "f1");

        window.location.href = url.toString();
    };

    return (
        <div className={styles.container}>

            <div className={styles.navigationHeader}>
                <div
                    className={styles.navigationBack}
                    onClick={() => navigate(-1)}
                >
                    <img src={ArrowLeft} alt="<" />
                </div>
                <div className={styles.navigationTitle}>
                    <p>premium upgrade</p>
                    <h2 className={styles.heading}>go premium</h2>
                </div>
            </div>

            {/* HERO CARD */}
            <div className={styles.heroCard}>
                <div className={styles.heroBadge}>👑 PREMIUM MEMBERSHIP</div>

                <h2 className={styles.heroTitle}>
                    PLAY ABOVE <br />
                    <span>THE REST.</span>
                </h2>

                <p className={styles.heroDesc}>
                    1.2× points · Free tournaments · Exclusive
                    gift shop only for Premium members.
                </p>

                <div className={styles.iconRow}>
                    {['🎮', '🎧', '📱', '💎', '🏆', '📦', '🕹️'].map((i, idx) => (
                        <div key={idx} className={styles.iconBox}>{i}</div>
                    ))}
                </div>
            </div>

            {/* TRIAL CARD */}
            <div className={styles.trialCard}>

                {/* <span className={styles.trialTag}>1-DAY FREE TRIAL</span> */}

                <div className={styles.freeRow}>
                    <div className={styles.freeLeft}>
                        <span className={styles.oldPrice}>1-DAY FREE TRIAL</span>
                    </div>

                    <div className={styles.priceRight}>
                        <strong>PKR 350</strong>
                        <span>/month after trial</span>
                    </div>
                </div>

                <div className={styles.trialNote}>
                    ★ NO PAYMENT TO START · CANCEL ANYTIME ★
                </div>

            </div>

            {/* CTA */}
            <button
                className={styles.ctaBtn}
                onClick={() => {
                    trackPremiumTrialStart();
                    onPremiumLpRedirect();
                }}
            >
                START FREE TRIAL →
            </button>

            {/* FEATURES */}
            <div className={styles.featuresRow}>
                <span><b>✓</b> No card needed</span>
                <span><b>✓</b> Cancel anytime</span>
                <span><b>✓</b> Instant unlock</span>
            </div>

            {/* MEMBERS */}
            {/* <div className={styles.membersCard}>
                <div className={styles.avatars}>
                    {['🎮', '🏆', '🎯', '🪙', '🎧'].map((i, idx) => (
                        <div key={idx} className={styles.avatar}>{i}</div>
                    ))}
                </div>

                <div>
                    <strong>12,400+ members</strong>
                    <p>have already upgraded to Premium this month</p>
                </div>

                <span className={styles.greenDot}></span>
            </div> */}

            {/* PERKS */}
            <div className={styles.section}>
                <h3 className={styles.sectionTitle}>PREMIUM PERKS</h3>

                {perks.map((perk, i) => (
                    <div key={i} className={styles.perkCard}>
                        <div className={`${styles.perkIconWrap} `}>{perk.icon}</div>

                        <div className={styles.perkContent}>
                            <h4>{perk.title}</h4>
                            <p>{perk.desc}</p>
                        </div>

                        <div className={styles.perkTag}>{perk.tag}</div>
                    </div>
                ))}
            </div>

            {/* POINTS CALCULATOR */}
            <div className={styles.section}>

                <h3 className={styles.sectionTitleAlt}>
                    ⚡ POINTS CALCULATOR
                </h3>

                <div className={styles.calculatorCard}>

                    <div className={styles.calcHeader}>
                        💚 SEE WHAT YOU’RE MISSING
                    </div>

                    <div className={styles.calcTableHeader}>
                        <span>ACTIVITY</span>
                        <span>BASIC</span>
                        <span>PREMIUM</span>
                    </div>

                    {[
                        { name: 'Daily Task', basic: '50 pts', premium: '60 pts' },
                        { name: 'Free Fire Match', basic: '80 pts', premium: '96 pts' },
                        { name: 'Weekly Tournament', basic: '200 pts', premium: '240 pts' },
                        { name: 'Check-in Streak', basic: '30 pts', premium: '36 pts' }
                    ].map((row, i) => (
                        <div key={i} className={styles.calcRow}>
                            <span>{row.name}</span>
                            <span className={styles.basicVal}>{row.basic}</span>

                            <span className={styles.premiumVal}>
                                {row.premium}
                                <small>+20%</small>
                            </span>
                        </div>
                    ))}

                    <div className={styles.calcFooter}>
                        <span>Extra points you earn per month (est.)</span>
                        <strong>+2,400 PTS 🚀</strong>
                    </div>

                </div>
            </div>


            {/* BASIC VS PREMIUM */}
            <div className={styles.section}>

                <h3 className={styles.sectionTitleAlt}>
                    🆚 BASIC vs PREMIUM
                </h3>

                <div className={styles.basicCard}>
                    <div className={styles.basicHeader}>
                        <span>BASIC</span>
                        <strong>FREE</strong>
                    </div>

                    <div className={styles.basicSub}>YOUR CURRENT PLAN</div>

                    <ul className={styles.basicList}>
                        <li className={styles.ok}>✓ Daily tasks & credits</li>
                        <li className={styles.ok}>✓ 1.0× point earning rate</li>
                        <li className={styles.no}>✕ Tournament entry fees apply</li>
                        <li className={styles.no}>✕ No exclusive gift shop</li>
                        <li className={styles.no}>✕ No VIP queue or badge</li>
                    </ul>
                </div>

                <div className={styles.upgradeDivider}>
                    <span>UPGRADE TO</span>
                </div>
                {/* PREMIUM UPGRADE CARD */}
                <div className={styles.premiumCard}>

                    <div className={styles.premiumHeader}>
                        <div>
                            <span className={styles.premiumBadge}>★ PREMIUM</span>
                            <div className={styles.premiumSub}>RECOMMENDED UPGRADE</div>
                        </div>

                        <div className={styles.premiumPrice}>
                            <strong>350</strong>
                            <span>PKR / month</span>
                        </div>
                    </div>

                    <ul className={styles.premiumList}>
                        <li>✓ Everything in Basic</li>
                        <li>✓ 1.2× Points on all activity</li>
                        <li>✓ Free Weekly Tournaments</li>
                        <li>✓ Exclusive Gift Shop unlocked</li>
                        <li>✓ Gold badge & VIP priority</li>
                        <li>✓ Priority customer support</li>
                    </ul>

                </div>


                {/* EXCLUSIVE GIFT SHOP */}
                <div className={styles.section}>

                    <h3 className={styles.sectionTitle}>
                        🎁 EXCLUSIVE GIFT SHOP
                    </h3>

                    <div className={styles.shopGrid}>

                        {[
                            { name: 'PLAYSTATION 5', pts: '120,000 PTS', credits: '1,200 credits', icon: '🎮' },
                            { name: 'GAMING MOUSE', pts: '18,000 PTS', credits: '1,1200 credits', icon: '🖱️' },
                            { name: 'WIRELESS HEADSET', pts: '24,000 PTS', credits: '1,000 credits', icon: '🎧' },
                            { name: 'GAMING KEYBOARD', pts: '32,000 PTS', credits: '1,280 credits', icon: '⌨️' }
                        ].map((item, i) => (
                            <div key={i} className={styles.shopCard}>

                                <span className={styles.shopPremium}>★ PREMIUM</span>

                                <div className={styles.shopIcon}>{item.icon}</div>

                                <h4>{item.name}</h4>

                                {/* <div className={styles.shopPts}>{item.pts}</div> */}

                                {/* <div className={styles.shopCredits}>
                                    or {item.credits}
                                </div> */}

                            </div>
                        ))}

                    </div>

                </div>

                {/* HOW IT WORKS */}
                <div className={styles.section}>

                    <h3 className={styles.sectionTitle}>
                        🧩 HOW IT WORKS
                    </h3>

                    {[
                        {
                            step: 1,
                            title: 'TAP START FREE TRIAL',
                            desc: 'Activate Premium in seconds — no card needed up front.'
                        },
                        {
                            step: 2,
                            title: 'EARN 1.2× INSTANTLY',
                            desc: 'Multiplier kicks in immediately. Free tournaments & gift shop open up.'
                        },
                        {
                            step: 3,
                            title: 'KEEP IT OR CANCEL',
                            desc: 'Love it? Stay for PKR 350/mo. Cancel anytime — keep all earned points.'
                        }
                    ].map((item, i) => (
                        <div key={i} className={styles.stepCard}>

                            <div className={styles.stepNumber}>{item.step}</div>

                            <div>
                                <h4>{item.title}</h4>
                                <p>{item.desc}</p>
                            </div>

                        </div>
                    ))}

                </div>


                {/* FINAL CTA */}
                <div className={styles.finalCta}>

                    <h2>
                        READY TO PLAY <br />
                        <span>ABOVE THE REST?</span>
                    </h2>

                    <p>
                        Join ESL members earning faster, competing free,
                        and redeeming pro gaming gear.
                    </p>

                    <button
                        className={styles.ctaBtn}
                        onClick={onPremiumLpRedirect}
                    >
                        START FREE TRIAL →
                    </button>

                </div>


                {/* FAQ */}
                {/* <div className={styles.section}>

                    <h3 className={styles.sectionTitleAlt}>
                        ❓ QUICK QUESTIONS
                    </h3>

                    {[
                        'Will I be charged during the trial?',
                        'What if I downgrade later?',
                        'Can I really redeem a PS5?',
                        'How do I cancel?'
                    ].map((q, i) => (
                        <div key={i} className={styles.faqItem}>
                            <span>{q}</span>
                            <b>+</b>
                        </div>
                    ))}

                </div> */}

                {/* FOOTER */}
                {/* <div className={styles.footer}>

                    <div className={styles.footerTop}>

                        <div className={styles.footerLinks}>
                            <h4>QUICK LINKS</h4>

                            <ul>
                                <li>Daily tasks</li>
                                <li>Rewards</li>
                                <li>Learn and win</li>
                                <li>Tournaments</li>
                                <li>Weekly</li>
                                <li>News</li>
                                <li>Highlights</li>
                            </ul>
                        </div>

                        <div className={styles.footerRight}>
                            <h3 className={styles.logo}>ESL</h3>

                            <div className={styles.socials}>
                                <span>f</span>
                                <span>▶</span>
                                <span>◎</span>
                                <span>✕</span>
                            </div>
                        </div>

                    </div>

                    <div className={styles.footerBottom}>
                        <p>Unleash Your E-Sports Potential With Just ESL</p>
                        <span>© 2026 All Rights Reserved</span>
                    </div>

                </div> */}

            </div>

        </div>
    );

};

export default PremiumUpgrade;